'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _DropdownWrapper = require('./DropdownWrapper');

var _DropdownWrapper2 = _interopRequireDefault(_DropdownWrapper);

var _DropdownButton = require('./DropdownButton');

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _DropdownButtonIcon = require('./DropdownButtonIcon');

var _DropdownButtonIcon2 = _interopRequireDefault(_DropdownButtonIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dropdownContentStyles = function dropdownContentStyles(_ref) {
  var open = _ref.open,
      inside = _ref.inside,
      mobile = _ref.mobile;
  return _extends({
    position: !inside ? 'fixed' : null,
    display: open ? 'block' : 'none',
    top: '48px',
    left: 0,
    width: '100%',
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    padding: !inside ? mobile && '16px' || '24px' : null,
    boxShadow: !inside ? '0 2px 4px 0 rgba(0, 0, 0, 0.1)' : null
  }, mobile && {
    overflowX: 'hidden',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch'

  }, {
    desktop: {
      position: 'absolute',
      top: '100%',
      left: '50%',
      width: 'auto',
      borderRadius: '3px',
      overflow: 'hidden',
      transform: 'translateX(-50%)',
      display: open ? 'flex' : 'none',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'flex-start'
    }
  });
};
var DropdownContent = (0, _preactFela.createComponent)(dropdownContentStyles);

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.ref = null;

    _this.toggleDropdown = function () {
      return _this.props.toggle();
    };

    _this.handleDocumentClick = function (e) {
      var container = _this.getContainer();
      if (container.contains(e.target) && container !== e.target) {
        return;
      }
      _this.toggleDropdown();
    };

    _this.handleClick = function (e) {
      var container = _this.getContainer();
      if (container.contains(e.target)) {
        _this.toggleDropdown();
      }
    };

    _this.handleRef = function (ref) {
      _this.ref = ref;
    };

    return _this;
  }

  _createClass(Dropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.handleProps();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this2 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      var _this3 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.open) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      return this.ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          mobile = _props.mobile,
          label = _props.label,
          ariaLabel = _props.ariaLabel,
          inside = _props.inside,
          config = _props.config,
          children = _props.children,
          inScroll = _props.inScroll,
          styleExtend = _props.styleExtend,
          loggedIn = _props.loggedIn,
          open = _props.open,
          _props$gtm = _props.gtm,
          gtm = _props$gtm === undefined ? {} : _props$gtm;


      var color = config.color;
      var inverseColor = config.inverseColor;

      return (0, _preact.h)(
        _DropdownWrapper2.default,
        {
          mobile: mobile,
          inScroll: inScroll,
          inside: inside,
          extend: styleExtend && styleExtend.wrapper,
          innerRef: this.handleRef
        },
        (0, _preact.h)(
          _DropdownButton2.default,
          _extends({
            open: open,
            'aria-haspopup': 'true',
            'aria-expanded': open ? 'true' : 'false',
            inside: inside,
            mobile: mobile,
            color: open && color,
            inScroll: inScroll,
            background: open && inverseColor,
            onClick: this.handleClick
          }, gtm),
          label,
          (0, _preact.h)(_DropdownButtonIcon2.default, { open: open, color: color, inside: inside })
        ),
        (0, _preact.h)(
          DropdownContent,
          { open: open, mobile: mobile, inside: inside, loggedIn: loggedIn, extend: styleExtend && styleExtend.dropdownContent },
          children
        )
      );
    }
  }]);

  return Dropdown;
}(_preact.Component);

exports.default = (0, _preactFela.connect)()(Dropdown);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Core/Dropdown/Dropdown.js
// module id = 191
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38